import { useTranslation } from '../../../../../translations';

export default function IsNew({ isNewFlag }) {
  const { t } = useTranslation();
  return isNewFlag && <span className={`button__new`}>{t('new')}</span>;
}
